import * as yup from 'yup'

const happyfoxHelpdeskAuthFormValidationSchema = yup
  .object({
    accountUrl: yup.string().trim().required('Account URL is required').url('Invalid account url'),
    apiKey: yup.string().trim().required('Api key is required').min(10, 'Invalid API Key'),
    authCode: yup.string().trim().required('Auth code is required').min(10, 'Invalid API Key')
  })
  .required()

export default happyfoxHelpdeskAuthFormValidationSchema
